import { makeAutoObservable } from 'mobx';
import moment from 'moment';

import { ExportLog } from '../models/ExportLog';
import { getLogs } from '../services/ExportLogsAPI';
import { formatValidDate } from '../services/shared';
import { FETCH_MESSAGE } from './Common';
import { errorStore } from './ErrorStore';

class ExportLogStore {
	data: ExportLog[] = [];
	isLoading: boolean = false;
	noRowsMessage: string = FETCH_MESSAGE;
	private requestVersion = 0;

	constructor() {
		makeAutoObservable(this);
	}

	async loadLogData(fromDate: moment.Moment, toDate: moment.Moment) {
		if (this.isLoading) return;
		const requestVersion = ++this.requestVersion;
		try {
			const fromDateStr = formatValidDate(fromDate.toISOString());
			const toDateStr = formatValidDate(toDate.toISOString());
			this.setLoading(true);
			const response = await getLogs(fromDateStr, toDateStr);
			if (requestVersion === this.requestVersion) {
				this.setData(response || [], true);
			}
		} catch (error: any) {
			if (requestVersion === this.requestVersion) {
				this.setError(error.message);
			}
		} finally {
			if (requestVersion === this.requestVersion) {
				this.setLoading(false);
			}
		}
	}

	setLoading(loading: boolean) {
		this.isLoading = loading;
	}

	setError(error: string) {
		errorStore.report(error);
	}

	setData(logs: ExportLog[], dataLoaded: boolean = false) {
		this.data = logs;
		if (this.data.length === 0) {
			this.noRowsMessage = dataLoaded ? 'No logs found.' : FETCH_MESSAGE;
		}
	}

	resetStore() {
		this.requestVersion++;
		this.isLoading = false;
		this.data = [];
		this.noRowsMessage = FETCH_MESSAGE;
	}
}

export const exportLogStore = new ExportLogStore();
